export default "__VITE_ASSET__ch9t0YmD__"